import api from './api';

const integrationService = {
  // Get all integrations with filters
  getAllIntegrations: async (params = {}) => {
    const response = await api.get('/integrations', { params });
    return {
      integrations: response.data.integrations || [],
      pagination: response.data.pagination || {}
    };
  },

  // Get integration by ID
  getIntegrationById: async (id) => {
    const response = await api.get(`/integrations/${id}`);
    return response.data;
  },

  // Create new integration
  createIntegration: async (integrationData) => {
    const response = await api.post('/integrations', integrationData);
    return response.data;
  },

  // Update integration
  updateIntegration: async (id, integrationData) => {
    const response = await api.put(`/integrations/${id}`, integrationData);
    return response.data;
  },

  // Delete integration
  deleteIntegration: async (id) => {
    const response = await api.delete(`/integrations/${id}`);
    return response.data;
  },

  // Test integration connection
  testIntegration: async (id) => {
    const response = await api.post(`/integrations/${id}/test`);
    return response.data;
  },

  // Sync integration
  syncIntegration: async (id) => {
    const response = await api.post(`/integrations/${id}/sync`);
    return response.data;
  },

  // Toggle integration (enable/disable)
  toggleIntegration: async (id) => {
    const response = await api.patch(`/integrations/${id}/toggle`);
    return response.data;
  },

  // Get integrations by type
  getIntegrationsByType: async (type) => {
    const response = await api.get(`/integrations/type/${type}`);
    return response.data;
  },

  // Get integration statistics
  getIntegrationStats: async () => {
    const response = await api.get('/integrations/meta/stats');
    return response.data;
  },
};

export default integrationService;

